import type { UserModel } from "@core/models/users/user.model";

const EMAIL_PATTERN: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function requiresPhoneNumber(user: UserModel | null | undefined): boolean {
  if (!user) return true;

  return !EMAIL_PATTERN.test(user.dni ?? "");
}
